module.exports = ".ad\r\n{\r\n    color:blue ;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/unicore-masters/agent-creations/agent-creations.component.css
// module id = ./src/app/unicore-masters/agent-creations/agent-creations.component.css
// module chunks = main